"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminContentListDataPayloadFromJSON = AdminContentListDataPayloadFromJSON;
exports.AdminContentListDataPayloadFromJSONTyped = AdminContentListDataPayloadFromJSONTyped;
exports.AdminContentListDataPayloadToJSON = AdminContentListDataPayloadToJSON;
exports.AdminContentListDataPayloadToJSONTyped = AdminContentListDataPayloadToJSONTyped;
const runtime_1 = require("../runtime");
function AdminContentListDataPayloadFromJSON(json) {
    return AdminContentListDataPayloadFromJSONTyped(json, false);
}
function AdminContentListDataPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'limit': !(0, runtime_1.exists)(json, 'limit') ? undefined : json['limit'],
        'offset': !(0, runtime_1.exists)(json, 'offset') ? undefined : json['offset'],
        'searchText': !(0, runtime_1.exists)(json, 'searchText') ? undefined : json['searchText'],
    };
}
function AdminContentListDataPayloadToJSON(value) {
    return AdminContentListDataPayloadToJSONTyped(value, false);
}
function AdminContentListDataPayloadToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'limit': value.limit,
        'offset': value.offset,
        'searchText': value.searchText,
    };
}
